import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useParams } from "react-router-dom";

//iconos
import { Assignment } from "@material-ui/icons";

//tabla y card components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

//servicios
import { wsFindBy } from "services/WService";

//modal
import Modal from "./Modal";
import { useModal } from "hooks/useModal";
import { Toasty, useToasty } from "hooks/Toasty";
import { WithApp } from "contexts/appContext";
import FilterArticle from "hooks/FilterArticle";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: "#", accessor: "num", excelEnabled: false },
  { Header: "Periodo", accessor: "period" },
  { Header: "Cuota", accessor: "quota" },
  { Header: "Cód. Vendedor", accessor: "SlpCode" },
  { Header: "Nombre vendedor", accessor: "SlpName" },
  { Header: "Cód. Proveedor", accessor: "CardCode" },
  { Header: "Nombre proveedor", accessor: "CardName" },
  { Header: "Marca", accessor: "logi_mark_description" },
  { Header: "Categoría", accessor: "logi_category_description" },
  { Header: "Familia", accessor: "logi_family_description" },
  { Header: "Zona", accessor: "base_zone_description" },
  { Header: "", accessor: "actions", excelEnabled: false }
];

export default WithApp(function QuotaDetail(props) {
  const classes = useStyles();

  const { id } = useParams();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [quotas, setQuotas] = useState([]); //constante para el listado
  const [valueSearch, setValueSearch] = useState({});

  //recargar Listado para usar en create y update
  async function listQuotaDetails(valueSearch) {
    let response = await wsFindBy("base/quota/" + id + "/daily", valueSearch);
    if (response.success) setQuotas(response.data);
  }

  return (
    <GridContainer>
      <Toasty action={notify} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              Listado de detalle de cuota
            </h4>
          </CardHeader>
          <CardBody>
            <FilterArticle
              getFilter={listQuotaDetails}
              setValueSearch={setValueSearch}
              mark
            />

            <ReactTable
              excelName="Detalle-de-cuotas"
              defaultWidth={2400}
              indexRow={[0, 1, 2, 11]}
              widthRow={[80, 80, 80, 0]}
              columns={columns}
              data={quotas.map((item, i) => {
                //mapeando listado para las acciones
                return {
                  num: i + 1,
                  period: item.period,
                  quota: item.quota,
                  SlpCode: item.SlpCode,
                  SlpName: item.SlpName,
                  CardCode: item.CardCode,
                  CardName: item.CardName,
                  logi_mark_description: item.logi_mark_description,
                  logi_category_description: item.logi_category_description,
                  logi_family_description: item.logi_family_description,
                  base_zone_description: item.base_zone_description,
                  actions: ""
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
